import { render, staticRenderFns } from "./MenuLogotype.vue?vue&type=template&id=c5ff3db4&scoped=true&"
import script from "./MenuLogotype.vue?vue&type=script&lang=js&"
export * from "./MenuLogotype.vue?vue&type=script&lang=js&"
import style0 from "./MenuLogotype.vue?vue&type=style&index=0&id=c5ff3db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ff3db4",
  null
  
)

export default component.exports